// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapPOIS_wrapper__1xutL","map_title_style":"MapPOIS_map_title_style__2A8fl"};